export default __webpack_public_path__ + "static/media/sale.76d6025b.jpg";